import { notification } from "@mtm/components";
import { sendEmailServiceUserAdded } from "../services/EmailNotificationService";
import * as AppSettingsService from "../services/AppSettingsService";
import {
  NotificationServiceUserAdded,
  TriggerEventId,
} from "../types/EmailNotificationType";
const appSettings = AppSettingsService;

const EmailServiceUserAdded = async (
  careGiverPersonId: number,
  organizationId: number,
  careGiverName: string,
  serviceUserPersonId: number,
  wandaCustomerCareNumber: string
) => {
  try {
    const serviceUserDetails: NotificationServiceUserAdded = {
      eventId: TriggerEventId.ServiceUserAdded,
      personId: careGiverPersonId,
      organizationId: organizationId,
      caregiverName: careGiverName,
      serviceUserPersonId: serviceUserPersonId,
      wandaAppBaseUrl: appSettings.getAppMapping().pp,
      customerServicePhone: wandaCustomerCareNumber,
    };
    await sendEmailServiceUserAdded(serviceUserDetails);
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to send email.",
    });
  }
};

export default EmailServiceUserAdded;
